function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Spinner, useOverlayContext } from 'seagull';
import ContactPicker from "../../ContactsPicker/ContactPicker";
import { NewContactModel } from "../../../models";
import { useEffect } from 'react';
import { ManageContactModalForVendor } from "../../ManageContactModal";
import { useContacts } from "../../../hooks/reactQuery/queries/useContacts";
import { GlobalBillModalErrorMessages } from "../GlobalBillModal.types";
import { jsx as _jsx } from "react/jsx-runtime";
const ContactsSelector = _ref => {
  let {
    onChange: _onChange,
    error,
    selectedContactId
  } = _ref;
  const overlayContext = useOverlayContext();
  const {
    contacts,
    error: contactsError,
    isFetching,
    refresh: fetchContacts
  } = useContacts({
    refreshOnMount: true
  });
  const selectedContact = contacts === null || contacts === void 0 ? void 0 : contacts.find(c => c.id() === selectedContactId);
  useEffect(() => {
    if (contactsError !== null) {
      overlayContext.showErrorToast(GlobalBillModalErrorMessages.FailedToRequestContacts, 'contacts-error-request-toast');
    }
  }, [contactsError]);
  async function openContactModal(props) {
    return overlayContext.showModal({
      closeOnEscapeKey: false,
      closeOnClickOutside: false,
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/_jsx(ManageContactModalForVendor, _objectSpread(_objectSpread({}, props), {}, {
          "data-testid": "manage-contact-modal",
          onClose: dismissModal,
          origin: "Global bill modal"
        }));
      }
    });
  }
  async function newContactPostActions(savedContact) {
    if (savedContact) {
      await fetchContacts();
      _onChange(savedContact.id());
    }
  }
  if (isFetching) {
    return /*#__PURE__*/_jsx(Spinner, {
      centeredInBox: true,
      size: 40,
      centerBoxHeight: 48
    });
  }
  return /*#__PURE__*/_jsx(ContactPicker, {
    label: "Contact to bill",
    hideSampleContact: true,
    value: selectedContact !== null && selectedContact !== void 0 ? selectedContact : NewContactModel.makeEmpty(),
    error: error,
    onChange: async change => {
      switch (change.type) {
        case 'existingContact':
          _onChange(change.id);
          break;
        case 'initial':
          _onChange(null);
          break;
        case 'newContact':
          {
            const savedContact = await openContactModal({});
            await newContactPostActions(savedContact);
            break;
          }
        default:
          break;
      }
    }
  });
};
export default ContactsSelector;